/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RequestModel } from '@app/sales/requests/request.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestsService } from '@app/sales/requests/requests.service';
import { Logger } from '@app/core';
import { ApiQuery } from '@app/core/http/api-query';
import { ClientFinderService } from '@app/shared/components/client-finder/client-finder.service';
import { ClientsFormService } from '@app/clients/clients/clients-form.service';
import { Client } from '@app/clients/clients/client.model';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { WebSocketsService } from '@app/core/websockets/websockets.service';
import { environment } from '@env/environment';

const log = new Logger('RequestsFormComponent');

@Component({
  selector: 'app-requests-form',
  templateUrl: './requests-form.component.html',
  styleUrls: ['./requests-form.component.scss'],
})
export class RequestsFormComponent implements OnInit, OnDestroy {
  @Input() request: RequestModel = null;
  form: FormGroup;
  clientSelectShow = true;
  env = environment;

  rawDataToggle = false;

  public laravelModels = LaravelModelsEnum;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private requestService: RequestsService,
    private clientFinderService: ClientFinderService,
    private clientsFormService: ClientsFormService,
    private _websockets: WebSocketsService
  ) {}

  ngOnInit() {
    log.debug('this.request', this.request);
    this.createForm();
    this.patchForm();
  }

  ngOnDestroy(): void {
    if (this.request && this.request.id) {
      this._websockets.userStatePop(LaravelModelsEnum.ENQUIRY, this.request.id);
    }
  }

  test(form: any) {
    log.debug(form);
  }

  save() {
    if (this.request && this.request.id) {
      this.requestService.update(this.form.value).subscribe((res) => this.modal.close('Save click'));
    }
  }

  openClientFinder() {
    let keyword = '';

    if (this.request.company_name) {
      keyword += this.request.company_name;
    }

    if (this.request.phone) {
      keyword += ' ' + this.request.phone;
    }

    if (this.request.email) {
      keyword += ' ' + this.request.email;
    }

    this.clientFinderService
      .open({
        keywords: keyword,
        // company_name: this.request.company_name,
        // phone: this.request.phone,
        // email: this.request.email
      })
      .then(
        (response) => {
          log.debug(response);

          // прост начин да re-init-не копмпонента app-client-select
          this.clientSelectShow = false;
          setTimeout(() => {
            this.clientSelectShow = true;
            setTimeout(() => {
              this.form.get('client_id').setValue(response[0].id);
            });
          });
        },
        (err) => {
          log.info('modal closed');
        }
      );
  }

  /**
   * Отваря едит на клиент и после го презарежда след промяната
   * @param clientId ID-то на клиента
   */
  editClient(clientId: Number): void {
    this.clientsFormService.open(new Client().deserialize({ id: clientId })).then((client: Client) => {
      if (client instanceof Client) {
        // прост начин да re-init-не копмпонента app-client-select
        this.clientSelectShow = false;
        setTimeout(() => {
          this.clientSelectShow = true;
          setTimeout(() => {
            this.form.get('client_id').setValue(client.id);
          });
        });
      }
    });
  }

  /**
   * Show raw request data
   */
  toggleRawData(): void {
    this.rawDataToggle = !this.rawDataToggle;
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      id: [null],
      client_id: [null],
      finished: [false, [Validators.required]],
      hotel_id: [null],
      event_id: [null],
      event_group_id: [null],
    });
  }

  private patchForm() {
    if (this.request && this.request.id) {
      const apiQuery: ApiQuery = new ApiQuery()
        .setLimit(0)
        .addIncludes(
          'company',
          'company_website',
          'event',
          'event_group',
          'rooms.meal_plan',
          'rooms.type',
          'hotel',
          'sale'
        );

      this.requestService.show(this.request.id, apiQuery).subscribe((request) => {
        this.form.patchValue(request);
        this.request = new RequestModel().deserialize(request);

        this._websockets.userStatePush(LaravelModelsEnum.ENQUIRY, this.request.id);
      });
    }
  }
}
